const QubitTermsAndConditions = () => {
  return (
    <div className="terms-conditions qubit">
      <h1 className="font-weight-bold text-center">Terms and Conditions</h1>
      <div className="content pr-0 container">
        <h3 className="mt-0">
          Welcome to <strong>Qubit</strong>
        </h3>
        <p>
          An exchange-approved, in-house algorithmic trading platform offered by
          <strong>Flattrade Broking Private Limited (“Flattrade”)</strong>. By accessing or using Qubit, you
          agree to be bound by these Terms & Conditions, along with applicable rules, regulations, circulars,
          and guidelines issued by the{' '}
          <strong>Securities and Exchange Board of India (SEBI)</strong> and recognized stock exchanges
          including NSE, BSE, and MCX.
        </p>

        <p>
          Qubit is a <strong>technology platform</strong> that enables users to:
        </p>
        <ul className="list-unstyled">
          <li>Create, test, and deploy algorithmic trading strategies</li>
          <li>Execute trades via Flattrade’s trading infrastructure</li>
        </ul>

        <p>Flattrade:</p>
        <ul className="list-unstyled">
          <li>
            <strong>Does not provide investment advice</strong>
          </li>
          <li>
            <strong>Does not recommend or endorse any strategy</strong>
          </li>
          <li>
            Acts only as a <strong>facilitator of order execution</strong>
          </li>
        </ul>

        <h2>User Responsibility</h2>
        <p>
          All strategies created and executed on Qubit are entirely based on the user’s own knowledge,
          judgment, and risk appetite, and the user shall be solely responsible for all trading decisions,
          strategy configurations, and outcomes arising thereof, while Flattrade bears no responsibility for
          any resulting profits or losses.
        </p>

        <h2>Regulatory Compliance</h2>
        <ul className="list-unstyled">
          <li>
            Users agree to comply with all applicable
            <strong>SEBI circulars on algorithmic trading</strong>, including API-based trading regulations.
          </li>
          <li>
            API keys and algo strategies must be used strictly in accordance with
            <strong>exchange-approved frameworks</strong>.
          </li>
          <li>
            Any misuse, manipulation, or non-compliance may result in:
            <ul className="list-unstyled">
              <li>Immediate suspension of access</li>
              <li>Reporting to regulatory authorities</li>
            </ul>
          </li>
        </ul>

        <h2>Backtesting Disclaimer</h2>
        <p>
          Backtesting features provided on Qubit are intended only for analytical and educational purposes
          using historical data, and users acknowledge that past performance does not guarantee future
          results, as actual market conditions may vary significantly due to volatility, slippage, liquidity
          constraints, and execution delays.
        </p>

        <h2>No Assurance of Returns</h2>
        <p>
          Flattrade does not make any representation, warranty, or guarantee regarding profits, returns, or
          capital protection, and the user expressly understands that all trading activities are subject to
          market risks, including the potential loss of entire capital.
        </p>

        <h2>No Refund Policy</h2>
        <p>
          All fees paid towards Qubit subscriptions are non-refundable under any circumstances, and once a
          payment is made, the user will continue to have access to the platform only for the subscribed
          period without any option for cancellation or refund.
        </p>

        <h2>Limitation of Liability</h2>
        <p>
          Flattrade shall not be liable for any direct or indirect losses, including but not limited to
          financial loss, loss of opportunity, or data loss, arising from the use of Qubit, including any
          technical failures, latency issues, or market-related risks.
        </p>
      </div>
    </div>
  );
};

export default QubitTermsAndConditions;
